import { ResponseData as AiVersion } from 'api/version/GetVersionAi';
import { ResponseData as TracenetVersion } from 'api/version/GetVersionTracenet';
import { ResponseData as BackendVersion } from 'api/version/GetVersionV1';
import { Type as DbVersion } from 'types/VersionInfo/DatabaseInfo';
import {
	GenericComponentVersionInfo,
	defaultGenericComponentVersionInfo,
} from 'types/VersionInfo/GenericComponentVersionInfo';
import { UIVersionInfoDto } from 'types/VersionInfo/UIVersionInfoDto';

export function mapUiVersionInfoToGenericVersionInfo(
	versionInfoDto: UIVersionInfoDto
): GenericComponentVersionInfo {
	const output: GenericComponentVersionInfo = defaultGenericComponentVersionInfo();
	output.componentName = 'AIR UI';
	output.branch = versionInfoDto.git_branch;
	output.buildDateUtc = new Date(versionInfoDto.build_date);
	output.buildId = versionInfoDto.build_id;
	output.hash = versionInfoDto.git_hash;
	output.version = versionInfoDto.version;

	return output;
}

export function mapDbVersionInfoToGenericVersionInfo(
	versionInfoDto: DbVersion | null
): GenericComponentVersionInfo {
	const output: GenericComponentVersionInfo = defaultGenericComponentVersionInfo();
	output.componentName = 'Database';
	if (versionInfoDto == null) {
		output.version = 'Database not found';
		return output;
	}

	output.version = versionInfoDto.label;
	output.buildDateUtc = new Date(versionInfoDto.init_time);

	return output;
}

export function mapBackendVersionInfoToGenericVersionInfo(
	versionInfoDto: BackendVersion | null
): GenericComponentVersionInfo {
	const output: GenericComponentVersionInfo = defaultGenericComponentVersionInfo();
	output.componentName = 'AIR API';
	if (versionInfoDto == null) {
		return output;
	}

	output.branch = versionInfoDto.branch;
	output.buildDateUtc = new Date(versionInfoDto.buildDateUtc);
	output.buildId = versionInfoDto.buildId;
	output.hash = versionInfoDto.hash;
	output.version = versionInfoDto.version;

	return output;
}

export function mapAiVersionInfoToGenericVersionInfo(
	versionInfoDto: AiVersion | null
): GenericComponentVersionInfo {
	const output: GenericComponentVersionInfo = defaultGenericComponentVersionInfo();
	output.componentName = 'AI API';
	if (versionInfoDto == null) {
		return output;
	}

	output.branch = versionInfoDto.git_branch;
	output.buildDateUtc = new Date(versionInfoDto.build_date);
	output.buildId = versionInfoDto.build_id;
	output.hash = versionInfoDto.git_hash;
	output.version = versionInfoDto.version;

	return output;
}

export function mapTracenetVersionInfoToGenericVersionInfo(
	versionInfoDto: TracenetVersion | null
): GenericComponentVersionInfo {
	const output: GenericComponentVersionInfo = defaultGenericComponentVersionInfo();
	output.componentName = 'Tracenet API';
	if (versionInfoDto == null) {
		return output;
	}

	output.branch = versionInfoDto.branch;
	output.buildDateUtc = new Date(versionInfoDto.buildDate);
	output.buildId = versionInfoDto.buildId;
	output.hash = versionInfoDto.hash;
	output.version = versionInfoDto.version;

	return output;
}
